module.exports = __webpack_public_path__ + "img/gold_symbol_6.c54e6ed6.png";